import React from "react";
import { NavLink as Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { Tooltip } from "@mui/material";
import { bgHandler } from "../helpers/styles.helper";
import { pageMenu } from "./menu";

const pageRoutes = [
  {
    path: pageMenu.homePage.path,
    header: pageMenu.homePage.text,
    icon: pageMenu.homePage.icon,
  },
  {
    path: pageMenu.portfolioPage.path,
    header: pageMenu.portfolioPage.text,
    icon: pageMenu.portfolioPage.icon,
  },
  {
    path: pageMenu.aboutPage.path,
    header: pageMenu.aboutPage.text,
    icon: pageMenu.aboutPage.icon,
  },
  {
    path: pageMenu.contactPage.path,
    header: pageMenu.contactPage.text,
    icon: pageMenu.contactPage.icon,
  },
  // {
  //   path: pageMenu.blogPage.path,
  //   header: pageMenu.blogPage.text,
  //   icon: pageMenu.blogPage.icon,
  // },
];

const NavRoutes = () => {
  return (
    <div className="navMenu">
      {pageRoutes.map((route) => (
        <Link
          to={route.path}
          key={route.header}
          className={({ isActive }) => (isActive ? "active" : undefined)}
          onClick={() => bgHandler(route.path)}
        >
          <Tooltip title={route.header}>
            <Button color="white" startIcon={route.icon} className="py-1 px-2">
              <span className="navBtnText">{route.header}</span>
            </Button>
          </Tooltip>
        </Link>
      ))}
    </div>
  );
};

export default NavRoutes;
